import React from "react";
import { ChevronDown, Languages } from "lucide-react";
import { Button } from "./ui/button";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuRadioGroup, DropdownMenuRadioItem } from "./ui/dropdown-menu";

const LANGUAGE_OPTIONS = [["zh", "中文"], ["en", "English"], ["es", "Español"]];

/**
 * 分包商窄屏顶栏直接提供语言入口，解决原语言组被全局 CSS 在 1536px 以下隐藏、只能逐层找设置的问题。
 * 紧凑按钮为 320px 手机保留搜索与通知空间；复用全局 setLang，切换后由 AppContext 保存偏好。
 * 语言使用各自名称且禁用自动翻译，避免用户在不熟悉的语言下找不到返回入口。
 */
export default function MobileLanguageMenu({ lang, onSelect }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button type="button" variant="outline" data-no-i18n data-testid="mobile-lang-toggle"
          aria-label="切换语言 / Language / Idioma" title="切换语言 / Language / Idioma"
          className="2xl:hidden h-11 shrink-0 gap-1.5 px-2.5 text-xs">
          <Languages aria-hidden="true" />
          <span>{lang === "zh" ? "中文" : lang === "es" ? "ES" : "EN"}</span>
          <ChevronDown aria-hidden="true" className="h-3 w-3" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" sideOffset={8} data-no-i18n data-testid="mobile-lang-menu">
        <DropdownMenuRadioGroup value={lang} onValueChange={onSelect} aria-label="语言 / Language / Idioma">
          {LANGUAGE_OPTIONS.map(([code, label]) => (
            <DropdownMenuRadioItem key={code} value={code} lang={code} data-testid={`mobile-lang-${code}`} className="min-h-11 pr-5 text-sm">
              {label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
